<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: 'SingleBarLong',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    },
    xy: {
      type: String,
      default: 'x'
    },
    barWidth: {
      type: Number,
      default: 36
    },
    unit: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default() {
        return null
      }
    },
    colorPairs: {
      type: Array,
      default() {
        return ['#1283e3', '#00d1e6']
      }
    },
    interval: {
      type: String,
      default: 'auto'
    },
    showPercentage: {
      type: Boolean,
      default: true
    },
    dataZoom: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    if (this.chartData) {
      this.initChart()
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      this.initChart()
    }
  },
  methods: {
    initChart() {
      var x = {
        type: 'category',
        axisTick: {
          show: false
        },
        axisLabel: {
          textStyle: {
            color: '#cbeeff',
            fontSize: 10
          },
          interval: this.interval
        },
        data: this.chartData.nameList
      }
      var y = {
        type: 'value',
        axisTick: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#414f5a',
            type: 'dashed'
          }
        },
        axisLabel: {
          textStyle: {
            color: '#cbeeff'
          },
          formatter: value => {
            return value + this.unit
          }
        }
      }
      var dataZoom = []
      if (this.dataZoom) {
        dataZoom = [{
          backgroundColor: 'rgba(47,69,84,0)',
          fillerColor: 'rgba(36,118,157,0.4)',
          borderColor: '#142439',
          dataBackground: {
            lineStyle: {
              color: '#00cdff'
            },
            areaStyle: {
              color: '#1a4b67'
            }
          },
          textStyle: {
            color: '#cbeeff'
          },
          start: 0,
          end: 40,
          bottom: 0,
          left: 0,
          right: 5,
          zoomLock: true
        }]
      }
      var total = 0
      this.chartData.data.forEach(el => {
        total += Number(el)
      })
      var option = {
        grid: {
          top: 20,
          bottom: this.dataZoom ? 35 : 0,
          left: 0,
          right: 10,
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}'
        },
        xAxis: this.xy == 'x' ? x : y,
        yAxis: this.xy == 'x' ? y : x,
        dataZoom: dataZoom,
        series: [
          {
            data: this.chartData.data,
            type: 'bar',
            barWidth: this.barWidth,
            itemStyle: {
              normal: {
                // 每根柱子颜色设置
                color: {
                  type: 'linear',
                  x: 1,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorPairs[0]
                    },
                    {
                      offset: 1,
                      color: this.colorPairs[1]
                    }
                  ],
                  globalCoord: false
                },
                label: {
                  show: true,
                  color: '#cbeeff',
                  fontSize: 10,
                  position: this.xy == 'x' ? 'top' : 'right',
                  formatter: params => {
                    return Math.round((params.value / total) * 100) + '%'
                  }
                }
              }
            }
          }
        ]
      }

      this.chart = this.$echarts.init(document.getElementById(this.id))
      this.chart.setOption(option)
    }
  }
}
</script>
<style scoped lang="less">
.chart {
  width: 100% !important;
  height: 100% !important;
}
</style>
